import { v4 as uuidv4 } from 'uuid';

export const getJobId = () => {
    return uuidv4();
};

// Only accept a safe id (letters, digits, dash, underscore; 8-64 chars) so a
// caller-supplied value can never escape the job's folder / report URL path.
export const SAFE_ID_RE = /^[A-Za-z0-9_-]{8,64}$/;

// The parent site (Bluebox) may generate the job id itself and pass it on the
// iframe URL as ?GUID=<uuid>. The key match is case-insensitive. Returns null
// when absent or not a safe id, so the caller falls back to a generated uuid.
export const getIncomingJobId = (search: string): string | null => {
    const params = new URLSearchParams(search);
    let value: string | null = null;
    params.forEach((v, k) => {
        if (!value && k.toLowerCase() === 'guid') {
            value = v;
        }
    });
    return value && SAFE_ID_RE.test(value) ? value : null;
};

// The parent site may pass a callback URL to which the portal POSTs the end
// result, as ?url=<https url> on the iframe src (case-insensitive key). The
// value must be percent-encoded by the caller if it carries its own query
// string. Returns null unless it parses as an http(s) URL, so a missing or
// malformed value is simply ignored (no relay happens). Host-level security
// (https-only, SSRF blocking) is enforced again server-side before we send.
const isHttpUrl = (value: string): boolean => {
    try {
        const parsed = new URL(value);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
};

export const getIncomingCallbackUrl = (search: string): string | null => {
    const params = new URLSearchParams(search);
    let raw: string | null = null;
    params.forEach((v, k) => {
        if (!raw && k.toLowerCase() === 'url') {
            raw = v;
        }
    });
    return raw && isHttpUrl(raw) ? raw : null;
};
